export default __webpack_public_path__ + "static/media/modals-complete.815a69c2.svg";